import { PlantListObject } from ".";

/* Import images */
import HSM400 from '../../Assets/Images/Machines/5-axis-hsm400.jpg';
import MIKRONHPM450U from '../../Assets/Images/Machines/5-Axis-MIKRONHPM450U.jpg';
import I400U from '../../Assets/Images/Machines/400-u.jpg';
import I700U from '../../Assets/Images/Machines/700u.png';
import ACCUT300SP from '../../Assets/Images/Machines/AC-CUT-300Sp.jpeg';
import AgieHyperSpark2 from '../../Assets/Images/Machines/agiehyperspark2.jpg';
import Cute600 from '../../Assets/Images/Machines/cute-600.jpg';
import SparkFormE600 from '../../Assets/Images/Machines/spark-form-e600.jpg';
import SparkChallengeV3 from '../../Assets/Images/Machines/Spark-Challenge_V3.jpg';
import SparkForm2000 from '../../Assets/Images/Machines/Spark-Form-2000.jpg';
import SparkInn03 from '../../Assets/Images/Machines/Spark-inn-03.jpg';
import Turn250MY from '../../Assets/Images/Machines/Turn-250my.png';
import TurnQT250 from '../../Assets/Images/Machines/Turn-QT250.png';
import UCP600 from '../../Assets/Images/Machines/ucp-600.png';
import VCE1200 from '../../Assets/Images/Machines/vce1200.jpg';
import Wire240 from '../../Assets/Images/Machines/Wire-240.jpg';
import WireCut300SP from '../../Assets/Images/Machines/Wire-cut-300-SP.jpg';
import WireCut300 from '../../Assets/Images/Machines/Wire-cut-300.jpg';
import Mecmesin from '../../Assets/Images/Machines/mecmesin.jpg';
import Cemb from '../../Assets/Images/Machines/cemb.jpg';

const fiveAxisMachines: PlantListObject[] = 
[
    {
        itemName: '+GF+ HSM 400U with 20 rotary pallet loader – 1 Off',
        plantListItem: {
            content: 'Efficiency In the HSM machines, accuracy, extreme dynamics and high machining speeds are combined with other important aspects such as outstanding swarf removal, high flexibility, good ergonomics and well-integrated automation. This machine embodies all the knowledge and experience gained in many years of high-speed cutting.',
            footerContent: 'X-travel 400 mm Y-travel 250 mm Z-travel 350 mm',
            image: HSM400
        }
    },
    {
        itemName: '+GF+ HPM 450U with 7 rotary pallet loader x 5 Off x 1 no pallet loader',
        plantListItem: {
            content: 'High-Speed and high performance milling centres, producing the workpieces in a process-secure and precise manner, increasing the reliability in unmanned operation, increasing the service life of the machine and significantly reducing production costs.',
            footerContent: 'X-travel 600mm Y-travel 450mm Z-travel 450mm',
            image: MIKRONHPM450U
        }
    },
    {
        itemName: '+GF+ UCP 600 Vario x 3 Off',
        plantListItem: {
            content: '5-axis machining offers considerable advantages for large and small components. By means of 5-axis technology it is possible to machine a wide variety of shapes and surfaces in one chucking.',
            footerContent: 'x-travel 530 mm y-travel 450 mm z-travel 450 mm',
            image: UCP600
        }
    },
    {
        itemName: '+GF+ Mill E 700U x 1 Off',
        plantListItem: {
            content: 'Milling machine built in a rigid and stable C construction made of cast iron. With their large-sized tracks and the double-            based rotary table provides this machine superior piece part quality and optimum cutting performance for best efficiency.',
            footerContent: 'X-travel 700mm Y-travel 600mm Z-travel 500mm',
            image: I700U
        }
    },
    {
        itemName: '+GF+ Mill S 400U x 2 Off with 72 piece robot for loading pallets',
        plantListItem: {
            content: 'The Mikron MILL S series leads precision chip removal into a new era. Precise adherence to the specified tool path even under high feed rates ultimately determines the surface quality of concave and convex surfaces.',
            footerContent: 'X-travel 500mm Y-travel 240mm Z-travel 360mm',
            image: I400U
        }
    },
    {
        itemName: '+GF+ VCE 1200 Pro x 1',
        plantListItem: {
            content: 'For a large range of applications the new Mikron VCE Pro-Range is the machine to be chosen. Whether 2½D or 3D application, the machine will not let you down. The standard machine has a performance, which fulfills most of the customers demands. With additional options the machine can be customized.',
            footerContent: 'X-travel 1200mm Y-travel 600mm Z-travel 675mm',
            image: VCE1200
        }
    }
];

const wirecutMachines: PlantListObject[] = 
[
    {
        itemName: '++GF++ Wire CUT 300Sp x 2',
        plantListItem: {
            content: 'The CUT 300 Sp is the most versatile machine range on the market, capable of cutting 45° cones, and can do this whatever the height of the part. The principle of crossed double guiding of the X, Y, U and V axes independently and of the same dimensions, allows machining to be done with a large taper, thus widening the scope of possible applications for wire spark erosion.',
            footerContent: 'X-Travel 549mm Y-Travel 349mm Z-Travel 400mm',
            image: ACCUT300SP
        }
    },
    {
        itemName: '++GF++ Wire CUT E600',
        plantListItem: {
            content: 'The CUT E600 range puts efficiency at the touch of your finger with a smart, easy-to-use human-machine interface (HMI) and onboard technologies that streamline your job setup, improve your cutting speed, improve your surface finish, protect your valuable workpieces, and ensure your process robustness.',
            footerContent: 'X-Travel 599mm Y-Travel 398 Z-Travel 347mm',
            image: Cute600
        }
    },
    {
        itemName: '++GF++ Wire CUT 300 x 2',
        plantListItem: {
            content: 'CUT300 Wire EDM, Swiss design and manufactured With: Millennium Control, 45 degree Taper, CC Digital Generator, ICP-Integrated Collision Protection, Taper-Expert, CT-Expert, Profile-Expert, Power-Expert, Surface-Expert',
            footerContent: 'X-Travel 550mm Y-Travel 350mm Z-Travel 400mm',
            image: WireCut300
        }
    },
    {
        itemName: '++GF++ Wire CUT 300mS',
        plantListItem: {
            content: 'The CUT 300 mS is the most versatile machine range on the market, capable of cutting 45° cones, and can do this whatever the height of the part. The principle of crossed double guiding of the X, Y, U and V axes independently and of the same dimensions, allows machining to be done with a large taper, thus widening the scope of possible applications for wire spark erosion.',
            footerContent: 'X-Travel 549mm Y-Travel 349mm Z-Travel 400mm',
            image: WireCut300SP
        }
    },
    {
        itemName: '++GF++ Wire CUT 240',
        plantListItem: {
            content: 'CUT240 Wire EDM, Swiss design and manufactured With: Millennium Control, 45 degree Taper, CC Digital Generator, ICP-Integrated Collision Protection, Taper-Expert, CT-Expert, Profile-Expert, Power-Expert, Surface-Expert',
            footerContent: 'X-Travel 350mm Y-Travel 220mm Z-Travel 220mm',
            image: Wire240
        }
    },
];

const turningMachines: PlantListObject[] = 
[
    {
        itemName: 'MAZAK QUICK TURN 250MY x 4 x 1 with Bar feed',
        plantListItem: {
            content: 'High Performance for demanding workpiece applications. Advanced features of the Mazak SmoothG CNC. The low thrust force ensures high accuracy turning even for small diameter shaft workpieces',
            footerContent: '',
            image: TurnQT250
        }
    },
]

const qualityMachines: PlantListObject[] = 
[
    {
        itemName: 'Mecmesin - MultiTest-dV',
        plantListItem: {
            content: 'The MultiTest-dV range configured with an Enhanced Load Sensor, VectorPro MT software and an optional extensometer, transforms this motorised force tester into a basic materials tester. This makes the MultiTest-dV the ideal choice for quality assurance checks in the QC lab and gives it the power necessary for more in-depth analysis of material properties.',
            footerContent: '',
            image: Mecmesin
        }
    },
    {
        itemName: 'CEMB - Balance Tester ZB-TO-2',
        plantListItem: {
            content: 'Balancing machine with belt drive for balancing of rotors with weight up to 5Kg. The special design of the driving system enables the machine to be operated with the belt placed on top of the rotor The machine base has got an articulated arm supporting the photocell for the detection of the reference mark on the rotor for the unbalance angular position and for the automatic synchronizing of the signal filtering.',
            footerContent: '',
            image: Cemb
        }
    },
]

export default fiveAxisMachines;
export const WireCutMachines = wirecutMachines;
export const TurningMachines = turningMachines;
export const QualityMachines = qualityMachines;